import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { customeFileItem, FileItem, FileItemState } from "./upload.models";

interface FileState {
  [key: string]: {
    error: string | null;
    file: FileItem | customeFileItem;
  };
}

interface Counter {
  currentlyUploadingFiles: number;
}

const initialState: { files: FileState; counter: Counter } = {
  files: {}, // This will hold file data
  counter: {
    currentlyUploadingFiles: 0, // This will store the count of files being uploaded
  },
};
export const uploadSlice = createSlice({
  name: "uploader",
  initialState,
  reducers: {
    addFile: (state, { payload }: PayloadAction<FileItemState>) => {
      if (
        ["png", "jpg", "jpeg", "gif", "svg", "webp"].some((ext) =>
          payload?.file?.identifier?.includes(ext)
        )
      ) {
        return;
      }
      state.files[payload.key] = {
        error: payload.error || null,
        file: payload.file,
      };
    },

    increaseCounter: (state) => {
      state.counter.currentlyUploadingFiles += 1;
    },

    decreaseCounter: (state) => {
      state.counter.currentlyUploadingFiles = Math.max(
        0,
        state.counter.currentlyUploadingFiles - 1
      );
    },

    updateFileProgress: (
      state,
      action: PayloadAction<{ identifier: string; progress: number }>
    ) => {
      const identifier = action.payload.identifier;
      const progress = action.payload.progress;
      const file: FileItem | customeFileItem = state.files[identifier]?.file;
      if (file) {
        file.progress = progress;
        file.uploadPhase = "uploading";
      }
    },
    setUploadedSuccessfully: (
      state,
      action: PayloadAction<{ identifier: string; flag: boolean }>
    ) => {
      const identifier = action.payload.identifier;
      const flag = action.payload.flag;
      const file: FileItem | customeFileItem = state?.files[identifier]?.file;
      if (file) {
        file.isUploadedSuccessfully = flag;
      }
    },
    setUploadingError: (
      state,
      { payload }: PayloadAction<{ uniqueIdentifier: string; error: string }>
    ) => {
      const { uniqueIdentifier, error } = payload;
      const file: FileItem | undefined | customeFileItem =
        state.files[uniqueIdentifier]?.file;
      if (file) {
        file.error = error;
      } else {
        console.error(`File with identifier ${uniqueIdentifier} not found`);
      }
    },
    setRemoveFile: (state, action: PayloadAction<{ identifier: string }>) => {
      const identifier = action.payload.identifier;
      if (state.files[identifier]) {
        delete state.files[identifier];
      }
    },
  },
});

export const {
  addFile,
  updateFileProgress,
  setUploadedSuccessfully,
  setUploadingError,
  setRemoveFile,
  increaseCounter,
  decreaseCounter,
} = uploadSlice.actions;

export default uploadSlice.reducer;
